import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {ref} from '../../config/firebase';

export default class Portfolio extends Component {
	constructor(props) {
		super(props);
		this.state = {
			items: []
		};

		this.dbItems = ref.child('portfolio');
	}

	componentDidMount() {
		this.dbItems.on("value", snapshot => {
			var items = [];


			snapshot.forEach(function(childSnapshot) {

				var item = childSnapshot.val();

				item['.key'] = childSnapshot.key;

				items.push(item);

			});

			this.setState({items});

		});

	}

	mapType(aType) {
		if(aType === 'web') {
			return <i className="fa fa-laptop"></i>;
		}
		else if(aType === 'mobile') {
			return <i className="fa fa-mobile"></i>;
		}

		return <i className="fa fa-desktop"></i>;
	}

  render() {
  	var white = {color:'#fff'};
  	var width100 = {width: '100%'};
  	var _this = this;

    return (
    	

      	<div className="container">
			<div className="row pt50 pb50">
				<div className="col-md-12">
					<h2 className="white uppercase pb20" style={white}><i className="fa fa-file-code-o"></i> Portfolio</h2>
				</div>
				{
					this.state.items.map(function(item) {

						return (
							<div className="col-md-4 col-sm-6 text-center" key={item['.key']}>
								<div className="panel panel-info">
									<div className="panel-heading">
										<p className="black bold uppercase pt10">{_this.mapType(item.type)} {item.name}</p>

									</div>
									<div className="panel-body">
										<img alt="img" src={item.img1} style={width100}/>
									</div>
									<div className="panel-footer">
										<a className="black" target="_blank" href={item.link} rel="noopener noreferrer"><i className="fa fa-info"></i> {item.usage}</a><br/>
										<Link className="black" to={"/detail_portfolio/"+item['.key']}><i className="fa fa-book"></i> Know More</Link>
									</div>
								</div>
							</div>
						);
					})
				}



			</div>
		</div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/components/Portfolio.js